// extracted by mini-css-extract-plugin
export default {"wixLogo":"kg_Jnw","appLogo":"d70MdB"};